const cplusplusOppsChapterList = [
    {
        chapterName: 'Introduction to C++ OOPS',
        is_bookmarked: false,
        time_required: '5 min',
        chapterFolderName: '1_introduction',
        topicsList: [
            {
                topicName: 'Understanding OOPS in C++',
                topicFileName: '1_understanding_oops',
            },
            {
                topicName: 'Classes and Objects',
                topicFileName: '2_classes_and_objects'
            },
         
        ]
    },
    {
        chapterName: 'Inheritance in C++',
        is_bookmarked: false,
        time_required: '25 min',
        chapterFolderName: '2_inheritance',

        topicsList: [
            {
                topicName: 'Introduction to Inheritance',
                topicFileName: '1_introduction_to_inheritance'
            },
            {
                topicName: 'Access Control',
                topicFileName: '2_access_control'
            },
            {
                topicName: 'Contructors and Destructors',
                topicFileName: '3_constructors_and_destructors'
            },
            {
                topicName: 'Types of Inheritance',
                topicFileName: '4_types_of_inheritance'
            },
            {
                topicName: 'Function Overriding and Polymorphsim',
                topicFileName: '5_function_overriding_and_polymorphism'
            },
            {
                topicName: 'Comman Pitfalls and Avoiding them',
                topicFileName: '6_avoiding_common_pitfalls'
            },
           
        ]
    },
    {
        chapterName: 'Polymorphism',
        is_bookmarked: false,
        time_required: '20 min',
        chapterFolderName: '3_polymorphism',

        topicsList: [
            {
                topicName: 'Introduction to Polymorphism',
                topicFileName: '1_intro_to_polymorphism'
            },
            {
                topicName: 'Function Overriding and Dynamic Polymorphism',
                topicFileName: '2_function_overriding_and_dynamic_polymorphism'
            },
            {
                topicName: 'Abstract Base Classes and Pure Virtual Functions',
                topicFileName: '3_abstract_base_classes_and_pure_virtual_functions'
            },
            {
                topicName: 'Run-Time Polymorphism and Late Binding',
                topicFileName: '4_run_time_polymorphism_and_late_binding'
            },
            {
                topicName: 'Operator Overloading and Polymorphism',
                topicFileName: '5_operator_overloading_and_polymorphism'
            },
            {
                topicName: 'Compile-Time Polymorphism (Static Polymorphism)',
                topicFileName: '6_compile_time_polymorphism_static_polymorphism'
            },
            {
                topicName: 'Polymorphism in the Standard Library',
                topicFileName: '7_polymorphism_in_the_standard_library'
            },
        ]
    },
    {
        chapterName: 'Encapsulation and Abstraction',
        is_bookmarked: false,
        time_required: '20 min',
        chapterFolderName: '4_encapsulation_and_abstraction',

        topicsList: [
            {
                topicName: 'Encapsulation and Data Hiding',
                topicFileName: '1_encapsulation_and_data_hiding'
            },
            {
                topicName: 'Getters and Setters',
                topicFileName: '2_getters_and_setters'
            },
            {
                topicName: 'Abstraction and Class Interfaces',
                topicFileName: '3_abstraction_and_class_interfaces'
            },
            {
                topicName: 'Using Abstract Classes and Interfaces',
                topicFileName: '4_using_abstract_classes_and_interfaces'
            },
        ]
    },
]

export { cplusplusOppsChapterList };
